import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface FilterBarProps {
  children: ReactNode;
  className?: string;
}

export function FilterBar({ children, className }: Readonly<FilterBarProps>) {
  return (
    <div className={cn('rounded-lg border border-border bg-muted/10 p-4', className)}>
      {children}
    </div>
  );
}
